module.exports = __webpack_public_path__ + "img/514.1bb4bd69.jpg";